<icc-list
        [searchable]="true"
        [items]="fillings"
        [itemTemplate]="'itemImgTitleDescription'"
        itemImgHeight="high"
        (select)="selectFilling($event)"
        [selected]="selectedFilling"
        [vertical]="true"
></icc-list>
